'use client'

import { CartItemDisplay } from '@cart/_components/a-cart-item-lines'
import { cartProductKey } from '@cart/_utils/cart-product-key'

import { CartProduct } from '../../../../_context/order-flow-context'

import type { PriceInfo } from '@cart/_hooks/use-cart-prices'


type APatientInfoCartPriceProbeProps = {
	cartProducts: CartProduct[]
	reportPrice: (key: string, info: PriceInfo) => void
}

/**
 * Hidden mounts of {@link CartItemDisplay} so {@link useCartPrices} aggregates the same totals as the sidebar.
 */
export function APatientInfoCartPriceProbe({ cartProducts, reportPrice }: APatientInfoCartPriceProbeProps) {
	return (
		<div className='hidden' aria-hidden>
			{cartProducts.map((product, idx) => {
				const key = cartProductKey(product, idx)
				return (
					<CartItemDisplay
						key={key}
						product={product}
						variant='sidebar'
						onPriceReport={(info: PriceInfo) => reportPrice(key, info)}
					/>
				)
			})}
		</div>
	)
}
